import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';

import { NgForm } from '@angular/forms';

import {
  CalendarOptions,
  FullCalendarComponent
} from '@fullcalendar/angular';

import dayGridPlugin from '@fullcalendar/angular/daygrid';
import timeGridPlugin from '@fullcalendar/angular/timegrid';
import interactionPlugin from '@fullcalendar/angular/interaction';
import themePlugin from '@fullcalendar/angular/themes/monarch';
import {
  DomSanitizer,
  SafeResourceUrl
} from '@angular/platform-browser';
import { OrderService } from 'src/app/services/order/order.service';
import { ShortCourseOrderModel } from 'src/app/core/ShortCourseOrderModel';
import { ActivatedRoute } from '@angular/router';

type CalendarView =
  | 'dayGridMonth'
  | 'timeGridWeek'
  | 'timeGridDay';


interface CourseTypeDefinition {
  id: string;
  label: string;
  color: string;
  textColor: string;
  courseCodes: string[];
}


interface CourseTypeFilter
  extends CourseTypeDefinition {
  count: number;
  selected: boolean;
}


interface VetEnrolAddress {
  Unit: string;
  Building: string;
  StreetNumber: string;
  StreetName: string;
  City: string;
  State: string;
  PCode: string;
}


interface VetEnrolLocation {
  Code: string;
  Name: string;
  StateCode: string;
  Description: string | null;
  Address: VetEnrolAddress;
}


interface VetEnrolCourse {
  id: number;
  name: string;
  title: string;
  description: string | null;

  start: string;
  end: string;
  allDay: boolean;

  backgroundColor: string;
  textColor: string;
  className: string;

  expired: boolean;

  CloseDate: string;
  StartDate: string;
  EndDate: string;

  QualName: string;
  QualCode: string;

  Amount: number;
  Vacancies: number;

  Linky: string;
  GroupLinky: string;

  Location: VetEnrolLocation | null;

  Prices: unknown[];
}


interface CourseEventDetails {
  courseTypeId: string;

  calendarCode: string;
  courseCode: string;
  courseName: string;

  description: string;

  startTime: string;
  endTime: string;

  vacancies: number;

  location: string;
  address: string;
  trainer: string;

  amount: number;

  enrolmentUrl: string;
  groupEnrolmentUrl: string;

  courseEndDate: string;
  registrationCloseDate: string;

  expired: boolean;
}


interface CalendarCourseEvent {
  id: string;
  title: string;
  start: string;
  allDay: boolean;

  backgroundColor: string;
  borderColor: string;
  textColor: string;

  extendedProps: CourseEventDetails;
}


interface SelectedShortCourse {
  id: string;
  title: string;
  courseTypeId: string;
  calendarCode: string;
  courseCode: string;
  courseName: string;
  description: string;
  startDate: string;
  endDate: string;
  registrationCloseDate: string;
  startTime: string;
  endTime: string;
  vacancies: number;
  location: string;
  address: string;
  trainer: string;
  amount: number;
  enrolmentUrl: string;
  groupEnrolmentUrl: string;
  backgroundColor: string;
  textColor: string;
  expired: boolean;
  duration: string;
}


interface CourseModalDetails {
  category: string;
  assessment: string;
  duration: string;
  classes: number;
  units: number;
  fee: number;
  fallbackDescription: string;
}


interface PaymentCustomer {
  givenName: string;
  familyName: string;
  email: string;
}


interface PaymentRequest {
  courseId: string;
  courseCode: string;
  courseName: string;
  courseDate: string;
  location: string;
  amount: number;
  enrolmentUrl: string;

  participant: PaymentCustomer;
}
interface CourseClassSession {
  date: string;
  startTime: string;
  endTime: string;
  trainer: string;
  location: string;
}


interface CourseUnitItem {
  code: string;
  name: string;
}
declare const bootstrap: any;
@Component({
  selector: 'app-new-course-list',
  templateUrl: './new-course-list.component.html',
  styleUrl: './new-course-list.component.scss'
})
export class NewCourseListComponent implements OnDestroy, OnInit {
// Store course calendar reference
@ViewChild('courseCalendar')
courseCalendar?: FullCalendarComponent;


// Control filter panel visibility
isFilterPanelOpen = true;

// Control course modal visibility
isCourseModalOpen = false;

// Control payment form visibility
isShowingPaymentForm = false;

// Track payment submission state
isPaymentSubmitting = false;

// Control upcoming course display
showAllUpcomingCourses = false;


// Store calendar title
calendarTitle = '';

// Store active calendar view
activeCalendarView: CalendarView =
  'dayGridMonth';


// Store selected date
selectedDate = '';

// Store selected location
selectedLocation = 'all';

// Store selected date range
selectedDateRange = 'this-month';


// Store all calendar courses
allCourses: CalendarCourseEvent[] = [];

// Store filtered calendar courses
filteredCourses: CalendarCourseEvent[] = [];

// Store course type filters
courseTypeFilters: CourseTypeFilter[] = [];


// Store selected short course
selectedShortCourse:
  SelectedShortCourse | null = null;


// Store payment customer details
paymentCustomer: PaymentCustomer = {
  givenName: '',
  familyName: '',
  email: ''
};


// Control map modal visibility
isMapModalOpen = false;

// Store selected map address
selectedMapAddress = '';

// Store map embed URL
mapEmbedUrl:
  SafeResourceUrl | null = null;

// Store Google Maps external URL
googleMapsExternalUrl = '';
  
  /*
   * Set this value when Linky and GroupLinky are
   * returned as relative URLs.
   *
   * Example:
   * https://your-vetenrol-domain.com/
   */
  private readonly vetEnrolBaseUrl = '';
  private readonly courseClassesByCode:
    Record<string, CourseClassSession[]> = {

      RIIHAN301E: [
        {
          date: '2026-07-25',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        },
        {
          date: '2026-07-26',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        }
      ],

      RIIWHS204E: [
        {
          date: '2026-07-25',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        },
        {
          date: '2026-07-26',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        },
        {
          date: '2026-07-27',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        }
      ],

      TLILIC0003: [
        {
          date: '2026-07-25',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        },
        {
          date: '2026-07-26',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        }
      ],

      TLILIC0005: [
        {
          date: '2026-07-25',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        },
        {
          date: '2026-07-26',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        },
        {
          date: '2026-07-27',
          startTime: '08:30 AM',
          endTime: '05:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        }
      ],

      UETDRMP007: [
        {
          date: '2026-07-25',
          startTime: '08:30 AM',
          endTime: '01:00 PM',
          trainer: 'Anna Serrano',
          location: 'ECB – Altona North VIC'
        }
      ]
    };

  private readonly courseUnitsByCode:
    Record<string, CourseUnitItem[]> = {

      RIIHAN301E: [
        {
          code: 'RIIHAN301E',
          name: 'Operate Elevating Work Platform'
        }
      ],

      RIIWHS204E: [
        {
          code: 'RIIWHS204E',
          name: 'Work Safely at Heights'
        }
      ],

      TLILIC0003: [
        {
          code: 'TLILIC0003',
          name: 'Licence to Operate a Forklift Truck'
        }
      ],

      TLILIC0005: [
        {
          code: 'TLILIC0020',
          name: 'Open Slewing Crane'
        },
        {
          code: 'RIIMP0320F',
          name: 'Excavator'
        },
        {
          code: 'CPCCLRG3002',
          name: 'Intermediate Rigging'
        },
        {
          code: 'RIIWHS204E',
          name: 'Work Safely at Heights'
        },
        {
          code: 'TLILIC0005',
          name: 'Operate EWP Above 11M'
        }
      ],

      UETDRMP007: [
        {
          code: 'UETDRMP007',
          name: 'Perform Rescue From a Live Low Voltage Panel'
        }
      ]
    };

  private readonly courseTypeDefinitions:
    CourseTypeDefinition[] = [
      {
        id: 'elevating-work-platform',
        label: 'Elevating Work Platform',
        color: '#0000FF',
        textColor: '#FFFFFF',
        courseCodes: ['RIIHAN301E']
      },
      {
        id: 'work-safely-at-heights',
        label: 'Work Safely at Heights',
        color: '#DC143C',
        textColor: '#FFFFFF',
        courseCodes: ['RIIWHS204E']
      },
      {
        id: 'forklift-truck',
        label: 'Forklift Truck',
        color: '#FFD700',
        textColor: '#000000',
        courseCodes: ['TLILIC0003']
      },
      {
        id: 'boom-type-ewp',
        label: 'Boom-Type EWP (11m+)',
        color: '#2E8B57',
        textColor: '#FFFFFF',
        courseCodes: ['TLILIC0005']
      },
      {
        id: 'low-voltage-panel',
        label: 'Low Voltage Panel',
        color: '#80FFFF',
        textColor: '#000000',
        courseCodes: [
          'UETDRMP005',
          'UETDRMP007'
        ]
      },
      {
        id: 'first-aid',
        label: 'First Aid',
        color: '#808080',
        textColor: '#FFFFFF',
        courseCodes: ['HLTAID011']
      },
      {
        id: 'other-course',
        label: 'Other Courses',
        color: '#808080',
        textColor: '#FFFFFF',
        courseCodes: []
      }
    ];


  private readonly defaultCourseModalDetails:
    CourseModalDetails = {
      category: 'Training Course',
      assessment:
        'Practical and Knowledge Assessment',
      duration: '1 Day',
      classes: 1,
      units: 1,
      fee: 0,
      fallbackDescription:
        'View the course details and available booking information.'
    };


  private readonly courseModalDetailsByCode:
    Record<string, CourseModalDetails> = {

      HLTAID011: {
        category: 'Short Course',
        assessment:
          'Short Course',
        duration: '1 Day',
        classes: 1,
        units: 1,
        fee: 0,
        fallbackDescription:
          'Develop the skills and knowledge required to provide a first aid response in a range of situations.'
      },

      RIIHAN301E: {
        category:
          'Short Course',
        assessment:
          'Short Course',
        duration: '1 Day',
        classes: 2,
        units: 4,
        fee: 245,
        fallbackDescription:
          'Develop the skills and knowledge required to operate an elevating work platform safely.'
      },

      RIIWHS204E: {
        category:
          'Short Course',
        assessment:
          'Short Course',
        duration: '1/2 Day',
        classes: 3,
        units: 5,
        fee: 245,
        fallbackDescription:
          'Learn how to identify hazards and safely perform work where there is a risk of falling.'
      },

      TLILIC0003: {
        category: 'Short Course',
        assessment:
          'Short Course',
        duration: '2 Days',
        classes: 2,
        units: 3,
        fee: 495,
        fallbackDescription:
          'Gain the skills and knowledge required to operate a forklift truck safely.'
      },

      TLILIC0005: {
        category: 'Short Course',
        assessment:
          'Short Course',
        duration: '3 Days',
        classes: 3,
        units: 5,
        fee: 795,
        fallbackDescription:
          'Gain the skills and knowledge required to operate a boom-type elevating work platform safely.'
      },

      UETDRMP005: {
        category:
          'Short Course',
        assessment:
          'Short Course',
        duration: '1/2 Day',
        classes: 1,
        units: 2,
        fee: 195,
        fallbackDescription:
          'Learn the emergency procedures required to perform a rescue from a live low-voltage panel.'
      },

      UETDRMP007: {
        category:
          'Short Course',
        assessment:
          'Short Course',
        duration: '1/2 Day',
        classes: 1,
        units: 2,
        fee: 195,
        fallbackDescription:
          'Learn the emergency procedures required to perform a rescue from a live low-voltage panel.'
      }
    };


  /*
   * This sample list uses the exact VETEnrol
   * response structure supplied to the component.
   *
   * Replace it with the service response by calling:
   *
   * this.setVetEnrolCourses(response);
   */
  private readonly initialVetEnrolCourses:
    VetEnrolCourse[] =  [
    {
        "id": 34424,
        "name": "ALT - (CPCWHS1001) Prepare to Work Safely in the Construction Industry",
        "title": "ALT - (CPCWHS1001) Prepare to Work Safely in the Construction Industry",
        "description": "UNIT DESCRIPTOR:\n\nThis unit of competency specifies the mandatory work health and safety training required prior to undertaking construction work. The unit requires the person to demonstrate personal awareness and knowledge of health and safety legislative requirements in order to work safely and prevent injury or harm to self and others. It covers identifying and orally reporting common construction hazards, understanding basic risk control measures, and identifying procedures for responding to potential incidents and emergencies. It also covers correctly selecting and fitting common personal protective equipment (PPE) used for construction work.\n\nThis unit meets the general construction induction training requirements of:\n\nPart 1.1 Definitions and Part 6.5 of the Model Work Health and Safety Regulations;\nDivision 11 of Part 3 of the Occupational Safety and Health Regulations 1996 for Western Australia; and\nDivision 3 of Part 5.1 of the Occupational Health and Safety Regulations 2007 for Victoria.\nIt is expected that site-specific induction training will be conducted prior to conducting construction work.\n\nLicensing, legislative, regulatory or certification requirements apply to this unit. Relevant work health and safety state and territory regulatory authorities should be consulted to confirm jurisdictional requirements.",
        "start": "2026-07-27T00:00:00",
        "end": "2026-07-27T00:00:00",
        "allDay": true,
        "backgroundColor": "#800080",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1785074400000)/",
        "StartDate": "/Date(1785074400000)/",
        "EndDate": "/Date(1785679200000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 11,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34424",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34424&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34334,
        "name": "ALT - (RIIWHS204E) Work Safely at Heights",
        "title": "ALT - (RIIWHS204E) Work Safely at Heights",
        "description": null,
        "start": "2026-07-20T00:00:00",
        "end": "2026-07-20T00:00:00",
        "allDay": true,
        "backgroundColor": "#DC143C",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1784469600000)/",
        "StartDate": "/Date(1784469600000)/",
        "EndDate": "/Date(1785074400000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 19,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34334",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34334&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34358,
        "name": "ALT - (RIIWHS204E) Work Safely at Heights",
        "title": "ALT - (RIIWHS204E) Work Safely at Heights",
        "description": null,
        "start": "2026-07-21T00:00:00",
        "end": "2026-07-21T00:00:00",
        "allDay": true,
        "backgroundColor": "#DC143C",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1784556000000)/",
        "StartDate": "/Date(1784556000000)/",
        "EndDate": "/Date(1785160800000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 20,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34358",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34358&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34368,
        "name": "ALT - (RIIWHS204E) Work Safely at Heights",
        "title": "ALT - (RIIWHS204E) Work Safely at Heights",
        "description": null,
        "start": "2026-07-22T00:00:00",
        "end": "2026-07-22T00:00:00",
        "allDay": true,
        "backgroundColor": "#DC143C",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1784642400000)/",
        "StartDate": "/Date(1784642400000)/",
        "EndDate": "/Date(1785247200000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 18,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34368",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34368&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34412,
        "name": "ALT - (RIIWHS204E) Work Safely at Heights",
        "title": "ALT - (RIIWHS204E) Work Safely at Heights",
        "description": null,
        "start": "2026-07-24T00:00:00",
        "end": "2026-07-24T00:00:00",
        "allDay": true,
        "backgroundColor": "#DC143C",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1784815200000)/",
        "StartDate": "/Date(1784815200000)/",
        "EndDate": "/Date(1785420000000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 19,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34412",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34412&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34423,
        "name": "ALT - (RIIWHS204E) Work Safely at Heights",
        "title": "ALT - (RIIWHS204E) Work Safely at Heights",
        "description": null,
        "start": "2026-07-27T00:00:00",
        "end": "2026-07-27T00:00:00",
        "allDay": true,
        "backgroundColor": "#DC143C",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1785074400000)/",
        "StartDate": "/Date(1785074400000)/",
        "EndDate": "/Date(1785679200000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 17,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34423",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34423&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    }, {
        "id": 34509,
        "name": "ALT - (CPCWHS1001) Prepare to Work Safely in the Construction Industry",
        "title": "ALT - (CPCWHS1001) Prepare to Work Safely in the Construction Industry",
        "description": "UNIT DESCRIPTOR:\n\nThis unit of competency specifies the mandatory work health and safety training required prior to undertaking construction work. The unit requires the person to demonstrate personal awareness and knowledge of health and safety legislative requirements in order to work safely and prevent injury or harm to self and others. It covers identifying and orally reporting common construction hazards, understanding basic risk control measures, and identifying procedures for responding to potential incidents and emergencies. It also covers correctly selecting and fitting common personal protective equipment (PPE) used for construction work.\n\nThis unit meets the general construction induction training requirements of:\n\nPart 1.1 Definitions and Part 6.5 of the Model Work Health and Safety Regulations;\nDivision 11 of Part 3 of the Occupational Safety and Health Regulations 1996 for Western Australia; and\nDivision 3 of Part 5.1 of the Occupational Health and Safety Regulations 2007 for Victoria.\nIt is expected that site-specific induction training will be conducted prior to conducting construction work.\n\nLicensing, legislative, regulatory or certification requirements apply to this unit. Relevant work health and safety state and territory regulatory authorities should be consulted to confirm jurisdictional requirements.",
        "start": "2026-08-05T00:00:00",
        "end": "2026-08-05T00:00:00",
        "allDay": true,
        "backgroundColor": "#800080",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": false,
        "CloseDate": "/Date(1785852000000)/",
        "StartDate": "/Date(1785852000000)/",
        "EndDate": "/Date(1786456800000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 12,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34509",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34509&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34390,
        "name": "ALT - (RIIHAN301E) Operate Elevating Work Platform",
        "title": "ALT - (RIIHAN301E) Operate Elevating Work Platform",
        "description": "UNIT DESCRIPTOR:\n\nThis unit describes the skills and knowledge required to operate an elevating work platform at any height.\n\nThis unit applies to those working in operational roles.\n\nThe work required in this unit relates to the National Standard for High Risk Work but this unit does not provide the licence. Licensing, legislative, regulatory or certification requirements that may apply to this unit can vary between states, territories and industry sectors, and must be sourced prior to applying this unit.\n\nThis unit alone does not provide sufficient skill to independently load and unload equipment. To perform this activity safely, personnel must either complete or be assisted by someone who has completed RIIHAN308F Load and Unload Plant or equivalent.",
        "start": "2026-07-22T00:00:00",
        "end": "2026-07-22T00:00:00",
        "allDay": true,
        "backgroundColor": "#0000FF",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1784642400000)/",
        "StartDate": "/Date(1784642400000)/",
        "EndDate": "/Date(1785160800000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 7,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34390",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34390&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34490,
        "name": "ALT - (RIIHAN301E) Operate Elevating Work Platform",
        "title": "ALT - (RIIHAN301E) Operate Elevating Work Platform",
        "description": "UNIT DESCRIPTOR:\n\nThis unit describes the skills and knowledge required to operate an elevating work platform at any height.\n\nThis unit applies to those working in operational roles.\n\nThe work required in this unit relates to the National Standard for High Risk Work but this unit does not provide the licence. Licensing, legislative, regulatory or certification requirements that may apply to this unit can vary between states, territories and industry sectors, and must be sourced prior to applying this unit.\n\nThis unit alone does not provide sufficient skill to independently load and unload equipment. To perform this activity safely, personnel must either complete or be assisted by someone who has completed RIIHAN308F Load and Unload Plant or equivalent.",
        "start": "2026-08-04T00:00:00",
        "end": "2026-08-04T00:00:00",
        "allDay": true,
        "backgroundColor": "#0000FF",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1785765600000)/",
        "StartDate": "/Date(1785765600000)/",
        "EndDate": "/Date(1786284000000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 12,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34490",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34490&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34483,
        "name": "ALT - (RIIWHS204E) Work Safely at Heights",
        "title": "ALT - (RIIWHS204E) Work Safely at Heights",
        "description": null,
        "start": "2026-08-04T00:00:00",
        "end": "2026-08-04T00:00:00",
        "allDay": true,
        "backgroundColor": "#DC143C",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1785765600000)/",
        "StartDate": "/Date(1785765600000)/",
        "EndDate": "/Date(1786370400000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 19,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34483",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34483&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34460,
        "name": "ALT - (TLILIC0003) Licence to Operate a Forklift Truck",
        "title": "ALT - (TLILIC0003) Licence to Operate a Forklift Truck",
        "description": "UNIT DESCRIPTOR:\n\nThis unit specifies the skills and knowledge required to operate a forklift truck safely in accordance with all relevant legislative requirements. Competence in this unit, does not in itself result in a HRWL licence to operate this plant.\n\nForklift truck means a powered industrial truck equipped with lifting media made up of a mast and an elevating load carriage to which is attached a pair of fork arms or other attachments that can be raised 900 mm or more above the ground, but does not include a pedestrian-operated truck or a pallet truck.\n\nA person performing this work is required to hold a forklift truck High Risk Work Licence (HRWL).\n\nThis unit requires a person operating a forklift truck to:\n- plan for the work/task\n- prepare for the work/task\n- perform work/task\n- pack up\n\n\nLICENSING/REGULATORY INFORMATION:\n\nLegislative and regulatory requirements are applicable to this unit of competency.\n\nThis unit is based on the licensing requirements of Part 4.5 of the Model Work Health and Safety (WHS) Regulations and meets Commonwealth, State and Territory HRWL requirements.\n\nThe National Assessment Instrument (NAI) is the mandated assessment for the HRWL to operate the relevant licencing class as detailed in this unit.",
        "start": "2026-08-01T00:00:00",
        "end": "2026-08-01T00:00:00",
        "allDay": true,
        "backgroundColor": "#FFD700",
        "textColor": "#000000",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1785506400000)/",
        "StartDate": "/Date(1785506400000)/",
        "EndDate": "/Date(1786284000000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 6,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34460",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34460&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34499,
        "name": "ALT - (TLILIC0003) Licence to Operate a Forklift Truck",
        "title": "ALT - (TLILIC0003) Licence to Operate a Forklift Truck",
        "description": "UNIT DESCRIPTOR:\n\nThis unit specifies the skills and knowledge required to operate a forklift truck safely in accordance with all relevant legislative requirements. Competence in this unit, does not in itself result in a HRWL licence to operate this plant.\n\nForklift truck means a powered industrial truck equipped with lifting media made up of a mast and an elevating load carriage to which is attached a pair of fork arms or other attachments that can be raised 900 mm or more above the ground, but does not include a pedestrian-operated truck or a pallet truck.\n\nA person performing this work is required to hold a forklift truck High Risk Work Licence (HRWL).\n\nThis unit requires a person operating a forklift truck to:\n- plan for the work/task\n- prepare for the work/task\n- perform work/task\n- pack up\n\n\nLICENSING/REGULATORY INFORMATION:\n\nLegislative and regulatory requirements are applicable to this unit of competency.\n\nThis unit is based on the licensing requirements of Part 4.5 of the Model Work Health and Safety (WHS) Regulations and meets Commonwealth, State and Territory HRWL requirements.\n\nThe National Assessment Instrument (NAI) is the mandated assessment for the HRWL to operate the relevant licencing class as detailed in this unit.",
        "start": "2026-08-05T00:00:00",
        "end": "2026-08-05T00:00:00",
        "allDay": true,
        "backgroundColor": "#FFD700",
        "textColor": "#000000",
        "className": "calendarEvent",
        "expired": false,
        "CloseDate": "/Date(1785852000000)/",
        "StartDate": "/Date(1785852000000)/",
        "EndDate": "/Date(1786629600000)/",
        "QualName": "",
        "QualCode": "",
        "Amount": 0,
        "Vacancies": 6,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34499",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34499&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34337,
        "name": "ALT - (TLILIC0005) Licence to Operate a Boom-Type Elevating Work Platform (Boom Length 11m or more)",
        "title": "ALT - (TLILIC0005) Licence to Operate a Boom-Type Elevating Work Platform (Boom Length 11m or more)",
        "description": "UNIT DESCRIPTOR:\nThis unit specifies the skills and knowledge required to safely operate a boom-type Elevating Work Platform (EWP) where the length of the boom is 11 metres or more in accordance with all relevant legislative requirements. Competence in this unit, does not in itself result in a Risk Work Licence (HRWL) to operate this plant.\n\nBoom-type elevating work platform means a telescoping device, hinged device, or articulated device, or any combination of these, used to support a platform on which personnel, equipment and materials may be elevated.\n\nA person performing this work is required to hold a boom-type elevating work platform HRWL.\n\nThis unit requires a person operating an EWP to:\n\n- plan for the work/task\n- prepare for the work/task\n- perform work/task\n- pack up.\n\nLICENSING/REGULATORY INFORMATION:\nLegislative and regulatory requirements are applicable to this unit of competency.\n\nThis unit is based on the licensing requirements of Part 4.5 of the Model Work Health and Safety (WHS) Regulations and meets Commonwealth, State and Territory HRWL requirements.\n\nThe National Assessment Instrument (NAI) is the mandated assessment for the HRWL to operate the relevant licencing class as detailed in this unit.",
        "start": "2026-07-20T00:00:00",
        "end": "2026-07-20T00:00:00",
        "allDay": true,
        "backgroundColor": "#2E8B57",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": true,
        "CloseDate": "/Date(1784469600000)/",
        "StartDate": "/Date(1784469600000)/",
        "EndDate": "/Date(1785247200000)/",
        "QualName": "Licence to operate a boom-type elevating work platform (boom lenght 11m or more)",
        "QualCode": "TLILIC0005",
        "Amount": 0,
        "Vacancies": 5,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34337",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34337&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    },
    {
        "id": 34501,
        "name": "ALT - (TLILIC0005) Licence to Operate a Boom-Type Elevating Work Platform (Boom Length 11m or more)",
        "title": "ALT - (TLILIC0005) Licence to Operate a Boom-Type Elevating Work Platform (Boom Length 11m or more)",
        "description": "UNIT DESCRIPTOR:\nThis unit specifies the skills and knowledge required to safely operate a boom-type Elevating Work Platform (EWP) where the length of the boom is 11 metres or more in accordance with all relevant legislative requirements. Competence in this unit, does not in itself result in a Risk Work Licence (HRWL) to operate this plant.\n\nBoom-type elevating work platform means a telescoping device, hinged device, or articulated device, or any combination of these, used to support a platform on which personnel, equipment and materials may be elevated.\n\nA person performing this work is required to hold a boom-type elevating work platform HRWL.\n\nThis unit requires a person operating an EWP to:\n\n- plan for the work/task\n- prepare for the work/task\n- perform work/task\n- pack up.\n\nLICENSING/REGULATORY INFORMATION:\nLegislative and regulatory requirements are applicable to this unit of competency.\n\nThis unit is based on the licensing requirements of Part 4.5 of the Model Work Health and Safety (WHS) Regulations and meets Commonwealth, State and Territory HRWL requirements.\n\nThe National Assessment Instrument (NAI) is the mandated assessment for the HRWL to operate the relevant licencing class as detailed in this unit.",
        "start": "2026-08-05T00:00:00",
        "end": "2026-08-05T00:00:00",
        "allDay": true,
        "backgroundColor": "#2E8B57",
        "textColor": "#FFFFFF",
        "className": "calendarEvent",
        "expired": false,
        "CloseDate": "/Date(1785852000000)/",
        "StartDate": "/Date(1785852000000)/",
        "EndDate": "/Date(1786629600000)/",
        "QualName": "Licence to operate a boom-type elevating work platform (boom lenght 11m or more)",
        "QualCode": "TLILIC0005",
        "Amount": 0,
        "Vacancies": 7,
        "Linky": "Default.aspx?clientID=VT-ECB&occuID=34501",
        "GroupLinky": "Default.aspx?clientID=VT-ECB&occuID=34501&group=true",
        "Location": {
            "Code": "7",
            "Name": "ECB - ALTONA NORTH VIC",
            "StateCode": "Vic",
            "Description": null,
            "Address": {
                "Unit": "",
                "Building": "",
                "StreetNumber": "580-598",
                "StreetName": "Kororoit Creek Road",
                "City": "Altona North",
                "State": "Vic",
                "PCode": "3025"
            }
        },
        "Prices": []
    }
];

  constructor(
    private readonly sanitizer:
      DomSanitizer,
    private orderService: OrderService,
    private route: ActivatedRoute,
  ) {
    this.setVetEnrolCourses(
      this.initialVetEnrolCourses
    );
  }
  ngOnInit(): void {
    this.checkStripeReturn();
  }


  checkStripeReturn(): void {
    const sessionId = this.route.snapshot.queryParamMap.get('session_id');
    if (!sessionId) return;
    const raw = sessionStorage.getItem('ecb_pending_booking');
    if (raw) {
      const pending = JSON.parse(raw);

      sessionStorage.removeItem('ecb_pending_booking');
    }

  }

  calendarOptions: CalendarOptions = {
    plugins: [
      themePlugin,
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin
    ],

    initialView: 'dayGridMonth',

    headerToolbar: false,

    height: 'auto',
    fixedWeekCount: false,
    showNonCurrentDates: true,
    displayEventTime: false,
    dayMaxEvents: 2,

    moreLinkText: (count) =>
      `+${count} more`,

    eventDisplay: 'block',
    nowIndicator: true,
    locale: 'en-AU',

    slotMinTime: '07:00:00',
    slotMaxTime: '19:00:00',
    slotDuration: '00:30:00',
    allDaySlot: true,

    events: [],

    datesSet: (info) => {
      this.calendarTitle =
        info.view.title;

      this.activeCalendarView =
        info.view.type as CalendarView;
    },

    dateClick: (info) => {
      this.selectCalendarDate(
        info.dateStr
      );
    },

    eventClick: (info) => {
      const selectedCourse =
        this.allCourses.find(
          (course) =>
            course.id === info.event.id
        );

      if (selectedCourse) {
        this.openCourseDetails(
          selectedCourse
        );
      }
    },

    /*
     * The installed FullCalendar version uses
     * dayCellClass rather than dayCellClassNames.
     */
    dayCellClass: (info) => {
      return (
        this.toDateKey(info.date) ===
        this.selectedDate
      )
        ? 'ecb-course-calendar-selected-day'
        : '';
    },

    eventDidMount: (info) => {
      const courseTypeId =
        String(
          info.event.extendedProps[
          'courseTypeId'
          ] ?? ''
        );

      const renderedCourse =
        this.allCourses.find(
          (course) =>
            course.id === info.event.id
        );

      const backgroundColor =
        renderedCourse?.backgroundColor ??
        this.getCourseTypeColor(
          courseTypeId
        );

      const textColor =
        renderedCourse?.textColor ??
        this.getCourseTypeTextColor(
          courseTypeId
        );

      this.applyEventElementColors(
        info.el,
        backgroundColor,
        textColor
      );
    },

    eventContent: (info) => {
      const courseTypeId =
        String(
          info.event.extendedProps[
          'courseTypeId'
          ] ?? ''
        );

      const renderedCourse =
        this.allCourses.find(
          (course) =>
            course.id === info.event.id
        );

      const backgroundColor =
        renderedCourse?.backgroundColor ??
        this.getCourseTypeColor(
          courseTypeId
        );

      const textColor =
        renderedCourse?.textColor ??
        this.getCourseTypeTextColor(
          courseTypeId
        );

      const eventWrapper =
        document.createElement('div');

      eventWrapper.className =
        'ecb-course-calendar-event-content';

      eventWrapper.style.width = '100%';
      eventWrapper.style.height = '100%';
      eventWrapper.style.boxSizing =
        'border-box';

      eventWrapper.style.backgroundColor =
        backgroundColor;

      eventWrapper.style.color =
        textColor;

      const codeElement =
        document.createElement('strong');

      codeElement.className =
        'ecb-course-calendar-event-code';

      codeElement.textContent =
        info.event.extendedProps[
        'calendarCode'
        ] ?? '';

      const nameElement =
        document.createElement('span');

      nameElement.className =
        'ecb-course-calendar-event-name';

      nameElement.textContent =
        info.event.extendedProps[
        'courseName'
        ] ?? info.event.title;

      eventWrapper.append(
        codeElement,
        nameElement
      );

      return {
        domNodes: [eventWrapper]
      };
    },
  };




  get locationOptions(): string[] {
    return Array.from(
      new Set(
        this.allCourses
          .map(
            (course) =>
              course.extendedProps.location
          )
          .filter(Boolean)
      )
    ).sort();
  }


  get selectedCourseModalDetails():
    CourseModalDetails {

    const courseCode =
      this.selectedShortCourse
        ?.courseCode ?? '';

    return this.getCourseModalDetails(
      courseCode
    );
  }


  get upcomingCourses():
    CalendarCourseEvent[] {

    const currentDate =
      this.startOfDay(new Date());

    const courses =
      this.filteredCourses
        .filter((course) => {
          const courseDate =
            this.parseDate(course.start);

          return (
            !course.extendedProps.expired &&
            courseDate.getTime() >=
            currentDate.getTime()
          );
        })
        .sort(
          (first, second) =>
            this.parseDate(
              first.start
            ).getTime() -
            this.parseDate(
              second.start
            ).getTime()
        );

    return this.showAllUpcomingCourses
      ? courses
      : courses.slice(0, 3);
  }


  /*
   * Call this method with the real service response.
   */
  setVetEnrolCourses(
    courses: VetEnrolCourse[] | null | undefined
  ): void {

    const safeCourses =
      Array.isArray(courses)
        ? courses
        : [];

    this.allCourses =
      safeCourses.map(
        (course) =>
          this.mapVetEnrolCourse(course)
      );

    this.filteredCourses = [
      ...this.allCourses
    ];

    this.refreshCourseTypeFilters();

    const initialCourse =
      this.allCourses.find(
        (course) =>
          !course.extendedProps.expired
      ) ??
      this.allCourses[0];

    if (initialCourse) {
      this.selectedDate =
        initialCourse.start;
    }

    this.calendarOptions = {
      ...this.calendarOptions,
      initialDate:
        initialCourse?.start,
      events: [
        ...this.filteredCourses
      ]
    };

    const calendarApi =
      this.courseCalendar?.getApi();

    if (
      calendarApi &&
      initialCourse
    ) {
      calendarApi.gotoDate(
        initialCourse.start
      );
    }
  }


  toggleFilterPanel(): void {
    this.isFilterPanelOpen =
      !this.isFilterPanelOpen;
  }


  toggleCourseType(
    courseTypeId: string
  ): void {

    const courseType =
      this.courseTypeFilters.find(
        (item) =>
          item.id === courseTypeId
      );

    if (courseType) {
      courseType.selected =
        !courseType.selected;
    }
  }


  updateLocation(
    event: Event
  ): void {

    this.selectedLocation =
      (
        event.target as
        HTMLSelectElement
      ).value;
  }


  updateDateRange(
    event: Event
  ): void {

    this.selectedDateRange =
      (
        event.target as
        HTMLSelectElement
      ).value;
  }


  clearAllFilters(): void {
    this.courseTypeFilters.forEach(
      (courseType) => {
        courseType.selected = true;
      }
    );

    this.selectedLocation = 'all';
    this.selectedDateRange = 'all';

    this.applyFilters();
  }


  applyFilters(): void {
    const selectedCourseTypeIds =
      this.courseTypeFilters
        .filter(
          (courseType) =>
            courseType.selected
        )
        .map(
          (courseType) =>
            courseType.id
        );

    const referenceDate =
      this.getCalendarReferenceDate();

    this.filteredCourses =
      this.allCourses.filter(
        (course) => {

          const matchesCourseType =
            selectedCourseTypeIds.includes(
              course.extendedProps
                .courseTypeId
            );

          const matchesLocation =
            this.selectedLocation ===
            'all' ||
            course.extendedProps.location ===
            this.selectedLocation;

          const matchesDateRange =
            this.matchesSelectedDateRange(
              course.start,
              referenceDate
            );

          return (
            matchesCourseType &&
            matchesLocation &&
            matchesDateRange
          );
        }
      );

    this.calendarOptions = {
      ...this.calendarOptions,
      events: [
        ...this.filteredCourses
      ]
    };
  }


  goToToday(): void {
    const calendarApi =
      this.courseCalendar?.getApi();

    if (!calendarApi) {
      return;
    }

    calendarApi.today();

    this.selectCalendarDate(
      this.toDateKey(
        calendarApi.getDate()
      )
    );
  }


  navigateCalendar(
    direction: 'previous' | 'next'
  ): void {

    const calendarApi =
      this.courseCalendar?.getApi();

    if (!calendarApi) {
      return;
    }

    if (
      direction === 'previous'
    ) {
      calendarApi.prev();
      return;
    }

    calendarApi.next();
  }


  changeCalendarView(
    viewName: CalendarView
  ): void {

    this.courseCalendar
      ?.getApi()
      .changeView(viewName);

    this.activeCalendarView =
      viewName;
  }


  selectCalendarDate(
    dateValue: string
  ): void {

    this.selectedDate =
      this.getDateOnly(dateValue);

    this.courseCalendar
      ?.getApi()
      .render();
  }


  toggleUpcomingCourses(): void {
    this.showAllUpcomingCourses =
      !this.showAllUpcomingCourses;
  }


  formatUpcomingDate(
    dateValue: string
  ): string {

    return this.parseDate(
      dateValue
    ).toLocaleDateString(
      'en-AU',
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }
    );
  }


  openCourseDetails(
    course: CalendarCourseEvent
  ): void {

    const details =
      course.extendedProps;

    this.selectedShortCourse = {
      id: course.id,
      title: course.title,

      courseTypeId:
        details.courseTypeId,

      calendarCode:
        details.calendarCode,

      courseCode:
        details.courseCode,

      courseName:
        details.courseName,

      description:
        details.description,

      startDate:
        course.start,

      endDate:
        details.courseEndDate ||
        course.start,

      registrationCloseDate:
        details.registrationCloseDate ||
        course.start,

      startTime:
        details.startTime,

      endTime:
        details.endTime,

      vacancies:
        details.vacancies,

      location:
        details.location,

      address:
        details.address,

      trainer:
        details.trainer,

      amount:
        details.amount,

      enrolmentUrl:
        details.enrolmentUrl,

      groupEnrolmentUrl:
        details.groupEnrolmentUrl,

      backgroundColor:
        course.backgroundColor,

      textColor:
        course.textColor,

      expired:
        details.expired,


      duration: this.getCourseModalDetails(
        details.courseCode
      ).duration
    };

    const vetTrackId = Number(course.id);
    const staticVacancies = Number(
      details.vacancies ?? 0
    );

    if (vetTrackId > 0) {
      this.loadAvailableSeats(
        vetTrackId,
        staticVacancies
      );
    }

    this.isShowingPaymentForm =
      false;

    this.resetPaymentCustomer();
    this.openCourseModal();
  }

 


  openCourseModal(): void {
    this.isCourseModalOpen = true;
    document.body.style.overflow =
      'hidden';
  }


  closeCourseModal(): void {
    this.isCourseModalOpen = false;
    this.isShowingPaymentForm = false;
    this.isPaymentSubmitting = false;

    this.closeClassesModal();
    this.closeUnitsModal();
    this.closeLocationMap();

    this.selectedShortCourse = null;

    this.resetPaymentCustomer();

    document.body.style.overflow = '';
  }


  openCourseEnrolment(): void {
    const course =
      this.selectedShortCourse;

    if (
      !course ||
      course.vacancies === 0 ||
      course.expired
    ) {
      return;
    }

    this.isShowingPaymentForm = true;
  }


  closePaymentForm(): void {
    this.isShowingPaymentForm = false;
    this.isPaymentSubmitting = false;

    this.resetPaymentCustomer();
  }


  submitCoursePayment(
    form: NgForm
  ): void {

    if (
      form.invalid ||
      !this.selectedShortCourse
    ) {
      form.control.markAllAsTouched();
      return;
    }

    this.isPaymentSubmitting = true;

    const paymentRequest:
      PaymentRequest = {

      courseId:
        this.selectedShortCourse.id,

      courseCode:
        this.selectedShortCourse
          .courseCode,

      courseName:
        this.selectedShortCourse
          .courseName,

      courseDate:
        this.selectedShortCourse
          .startDate,

      location:
        this.selectedShortCourse
          .location,

      amount:
        this.selectedShortCourse
          .amount,

      enrolmentUrl:
        this.selectedShortCourse
          .enrolmentUrl,

      participant: {
        givenName:
          this.paymentCustomer
            .givenName.trim(),

        familyName:
          this.paymentCustomer
            .familyName.trim(),

        email:
          this.paymentCustomer
            .email.trim()
      }
    };

    console.log(
      'Payment request:',
      paymentRequest
    );

    /*
     * Connect your payment service here.
     *
     * After a successful payment, use
     * paymentRequest.enrolmentUrl if the user
     * must be redirected to VETEnrol.
     */

    this.isPaymentSubmitting = false;
  }


  private resetPaymentCustomer(): void {
    this.paymentCustomer = {
      givenName: '',
      familyName: '',
      email: ''
    };
  }

  trackByCourseTypeId(
    index: number,
    courseType: CourseTypeFilter
  ): string {
    return courseType.id;
  }


  trackByCourseId(
    index: number,
    course: CalendarCourseEvent
  ): string {
    return course.id;
  }
  isClassesModalOpen: boolean = false;
  isUnitsModalOpen: boolean = false;
  @HostListener(
    'document:keydown.escape'
  )
  handleEscapeKey(): void {

    if (this.isClassesModalOpen) {
      this.closeClassesModal();
      return;
    }

    if (this.isUnitsModalOpen) {
      this.closeUnitsModal();
      return;
    }

    if (this.isMapModalOpen) {
      this.closeLocationMap();
      return;
    }

    if (this.isCourseModalOpen) {
      this.closeCourseModal();
    }
  }


  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }


  private mapVetEnrolCourse(
    course: VetEnrolCourse
  ): CalendarCourseEvent {

    const courseCode =
      course.QualCode?.trim() ||
      this.extractCourseCode(
        course.title
      );

    const courseName =
      this.extractCourseName(
        course.title
      ) ||
      course.QualName?.trim() ||
      course.title;

    const courseTypeId =
      this.getCourseTypeIdFromCode(
        courseCode
      );

    const definition =
      this.getCourseTypeDefinition(
        courseTypeId
      );

    const backgroundColor =
      this.normaliseColor(
        course.backgroundColor,
        definition.color
      );

    const textColor =
      this.normaliseColor(
        course.textColor,
        definition.textColor
      );

    const startDate =
      this.getDateOnly(
        course.start
      );

    const courseEndDate =
      this.parseVetEnrolDate(
        course.EndDate
      ) ||
      this.getDateOnly(
        course.end
      ) ||
      startDate;

    const registrationCloseDate =
      this.parseVetEnrolDate(
        course.CloseDate
      ) ||
      startDate;

    const modalDetails =
      this.getCourseModalDetails(
        courseCode
      );

    return {
      id: String(course.id),
      title:
        course.title ||
        course.name,

      start: startDate,
      allDay: course.allDay,

      backgroundColor,
      borderColor: backgroundColor,
      textColor,

      extendedProps: {
        courseTypeId,

        calendarCode:
          this.extractCalendarCode(
            course.title
          ),

        courseCode,
        courseName,

        description:
          this.getCourseDescription(
            course.description,
            modalDetails
              .fallbackDescription
          ),

        /*
         * The supplied response does not include
         * session start and end times.
         */
        startTime: '',
        endTime: '',

        vacancies:
          course.Vacancies ?? 0,

        location:
          course.Location
            ?.Name?.trim() ||
          'Location not available',

        address:
          this.buildCourseAddress(
            course.Location?.Address
          ),

        trainer: 'ECB Training',

        amount:
          course.Amount > 0
            ? course.Amount
            : modalDetails.fee,

        enrolmentUrl:
          this.buildVetEnrolUrl(
            course.Linky
          ),

        groupEnrolmentUrl:
          this.buildVetEnrolUrl(
            course.GroupLinky
          ),

        courseEndDate,
        registrationCloseDate,

        expired:
          Boolean(course.expired)
      }
    };
  }


  private refreshCourseTypeFilters():
    void {

    const previousSelection =
      new Map(
        this.courseTypeFilters.map(
          (filter) => [
            filter.id,
            filter.selected
          ]
        )
      );

    this.courseTypeFilters =
      this.courseTypeDefinitions
        .map((definition) => {
          const count =
            this.allCourses.filter(
              (course) =>
                course.extendedProps
                  .courseTypeId ===
                definition.id
            ).length;

          return {
            ...definition,
            count,
            selected:
              previousSelection.get(
                definition.id
              ) ?? true
          };
        })
        .filter(
          (filter) =>
            filter.count > 0
        );
  }


  private getCourseModalDetails(
    courseCode: string
  ): CourseModalDetails {

    return (
      this.courseModalDetailsByCode[
      courseCode
      ] ??
      this.defaultCourseModalDetails
    );
  }


  private getCourseTypeIdFromCode(
    courseCode: string
  ): string {

    const definition =
      this.courseTypeDefinitions.find(
        (item) =>
          item.courseCodes.includes(
            courseCode
          )
      );

    return (
      definition?.id ??
      'other-course'
    );
  }


  private getCourseTypeDefinition(
    courseTypeId: string
  ): CourseTypeDefinition {

    return (
      this.courseTypeDefinitions.find(
        (item) =>
          item.id === courseTypeId
      ) ??
      this.courseTypeDefinitions[
      this.courseTypeDefinitions.length - 1
      ]
    );
  }


  private getCourseTypeColor(
    courseTypeId: string
  ): string {

    return this.getCourseTypeDefinition(
      courseTypeId
    ).color;
  }


  private getCourseTypeTextColor(
    courseTypeId: string
  ): string {

    return this.getCourseTypeDefinition(
      courseTypeId
    ).textColor;
  }


  private extractCourseCode(
    title: string
  ): string {

    const result =
      title?.match(/\(([^)]+)\)/);

    return result?.[1]?.trim() ?? '';
  }


  private extractCourseName(
    title: string
  ): string {

    if (!title) {
      return '';
    }

    return title
      .replace(
        /^.*?-\s*\([^)]+\)\s*/,
        ''
      )
      .trim();
  }


  private extractCalendarCode(
    title: string
  ): string {

    const result =
      title?.match(
        /^(.*?-\s*\([^)]+\))/
      );

    return (
      result?.[1]?.trim() ??
      title ??
      ''
    );
  }


  private getCourseDescription(
    description: string | null,
    fallbackDescription: string
  ): string {

    if (!description?.trim()) {
      return fallbackDescription;
    }

    const paragraphs =
      description
        .replace(
          /\r/g,
          ''
        )
        .split(/\n{2,}/)
        .map(
          (paragraph) =>
            paragraph.trim()
        )
        .filter(
          (paragraph) =>
            Boolean(paragraph) &&
            !/^[A-Z][A-Z/\s-]+:$/.test(
              paragraph
            )
        );

    const firstParagraph =
      paragraphs[0] ??
      description.trim();

    if (
      firstParagraph.length <= 420
    ) {
      return firstParagraph;
    }

    const shortened =
      firstParagraph.slice(
        0,
        420
      );

    const lastSentenceEnd =
      Math.max(
        shortened.lastIndexOf('.'),
        shortened.lastIndexOf('!'),
        shortened.lastIndexOf('?')
      );

    return (
      lastSentenceEnd > 120
        ? shortened.slice(
          0,
          lastSentenceEnd + 1
        )
        : `${shortened.trim()}…`
    );
  }


  private buildCourseAddress(
    address?: VetEnrolAddress
  ): string {

    if (!address) {
      return '';
    }

    const buildingDetails = [
      address.Unit,
      address.Building
    ]
      .filter(Boolean)
      .join(' ');

    const streetDetails = [
      address.StreetNumber,
      address.StreetName
    ]
      .filter(Boolean)
      .join(' ');

    return [
      buildingDetails,
      streetDetails,
      address.City,
      address.State,
      address.PCode
    ]
      .filter(Boolean)
      .join(', ');
  }


  private buildVetEnrolUrl(
    relativeUrl?: string
  ): string {

    if (!relativeUrl) {
      return '';
    }

    if (
      /^https?:\/\//i.test(
        relativeUrl
      )
    ) {
      return relativeUrl;
    }

    if (!this.vetEnrolBaseUrl) {
      return relativeUrl;
    }

    try {
      return new URL(
        relativeUrl,
        this.vetEnrolBaseUrl
      ).toString();
    } catch {
      return relativeUrl;
    }
  }


  private openExternalUrl(
    url: string
  ): void {

    window.open(
      url,
      '_blank',
      'noopener,noreferrer'
    );
  }


  private normaliseColor(
    color: string | undefined,
    fallbackColor: string
  ): string {

    const trimmedColor =
      color?.trim();

    return (
      trimmedColor ||
      fallbackColor
    );
  }


  private applyEventElementColors(
    eventElement: HTMLElement,
    backgroundColor: string,
    textColor: string
  ): void {

    eventElement.style.setProperty(
      '--fc-event-bg-color',
      backgroundColor
    );

    eventElement.style.setProperty(
      '--fc-event-border-color',
      backgroundColor
    );

    eventElement.style.setProperty(
      '--fc-event-text-color',
      textColor
    );

    eventElement.style.setProperty(
      'background-color',
      backgroundColor,
      'important'
    );

    eventElement.style.setProperty(
      'border-color',
      backgroundColor,
      'important'
    );

    eventElement.style.setProperty(
      'color',
      textColor,
      'important'
    );

    const eventMain =
      eventElement.querySelector<
        HTMLElement
      >('.fc-event-main');

    if (eventMain) {
      eventMain.style.setProperty(
        'background-color',
        backgroundColor,
        'important'
      );

      eventMain.style.setProperty(
        'color',
        textColor,
        'important'
      );
    }
  }


  private parseVetEnrolDate(
    dateValue?: string
  ): string {

    if (!dateValue) {
      return '';
    }

    const result =
      dateValue.match(
        /\/Date\((\d+)(?:[+-]\d+)?\)\//
      );

    if (!result) {
      return this.getDateOnly(
        dateValue
      );
    }

    const date =
      new Date(
        Number(result[1])
      );

    const dateParts =
      new Intl.DateTimeFormat(
        'en-AU',
        {
          timeZone:
            'Australia/Melbourne',

          year:
            'numeric',

          month:
            '2-digit',

          day:
            '2-digit'
        }
      ).formatToParts(date);

    const year =
      dateParts.find(
        (part) =>
          part.type === 'year'
      )?.value;

    const month =
      dateParts.find(
        (part) =>
          part.type === 'month'
      )?.value;

    const day =
      dateParts.find(
        (part) =>
          part.type === 'day'
      )?.value;

    if (
      !year ||
      !month ||
      !day
    ) {
      return '';
    }

    return `${year}-${month}-${day}`;
  }


  private getDateOnly(
    dateValue: string
  ): string {

    return dateValue
      ? dateValue.split('T')[0]
      : '';
  }


  private getCalendarReferenceDate():
    Date {

    const calendarDate =
      this.courseCalendar
        ?.getApi()
        .getDate();

    if (calendarDate) {
      return this.startOfDay(
        calendarDate
      );
    }

    return this.startOfDay(
      new Date()
    );
  }


  private matchesSelectedDateRange(
    courseDateValue: string,
    referenceDate: Date
  ): boolean {

    const courseDate =
      this.parseDate(
        courseDateValue
      );

    if (
      this.selectedDateRange ===
      'all'
    ) {
      return true;
    }

    if (
      this.selectedDateRange ===
      'this-month'
    ) {
      return (
        courseDate.getFullYear() ===
        referenceDate.getFullYear() &&
        courseDate.getMonth() ===
        referenceDate.getMonth()
      );
    }

    const rangeEndDate =
      new Date(referenceDate);

    if (
      this.selectedDateRange ===
      'next-30'
    ) {
      rangeEndDate.setDate(
        rangeEndDate.getDate() + 30
      );
    }

    if (
      this.selectedDateRange ===
      'next-90'
    ) {
      rangeEndDate.setDate(
        rangeEndDate.getDate() + 90
      );
    }

    return (
      courseDate.getTime() >=
      referenceDate.getTime() &&
      courseDate.getTime() <=
      rangeEndDate.getTime()
    );
  }


  private parseDate(
    dateValue: string
  ): Date {

    return new Date(
      `${this.getDateOnly(dateValue)}T00:00:00`
    );
  }


  private startOfDay(
    dateValue: Date
  ): Date {

    return new Date(
      dateValue.getFullYear(),
      dateValue.getMonth(),
      dateValue.getDate()
    );
  }


  private toDateKey(
    dateValue: Date
  ): string {

    const year =
      dateValue.getFullYear();

    const month =
      String(
        dateValue.getMonth() + 1
      ).padStart(2, '0');

    const day =
      String(
        dateValue.getDate()
      ).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }



  openLocationMap(): void {
    const course =
      this.selectedShortCourse;

    if (!course) {
      return;
    }

    const address =
      course.address?.trim() ||
      course.location?.trim();

    if (!address) {
      return;
    }

    this.selectedMapAddress =
      address;

    const encodedAddress =
      encodeURIComponent(address);

    const embedUrl =
      `https://www.google.com/maps?q=${encodedAddress}&output=embed`;

    this.mapEmbedUrl =
      this.sanitizer
        .bypassSecurityTrustResourceUrl(
          embedUrl
        );

    this.googleMapsExternalUrl =
      `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    this.isMapModalOpen = true;
  }


  closeLocationMap(): void {
    this.isMapModalOpen = false;
    this.selectedMapAddress = '';
    this.mapEmbedUrl = null;
    this.googleMapsExternalUrl = '';
  }


  get selectedCourseClasses():
    CourseClassSession[] {

    const courseCode =
      this.selectedShortCourse?.courseCode ?? '';

    return (
      this.courseClassesByCode[courseCode] ??
      []
    );
  }


  get selectedCourseUnits():
    CourseUnitItem[] {

    const courseCode =
      this.selectedShortCourse?.courseCode ?? '';

    return (
      this.courseUnitsByCode[courseCode] ??
      []
    );
  }
  openClassesModal(): void {
    if (!this.selectedShortCourse) {
      return;
    }

    this.isUnitsModalOpen = false;
    this.isClassesModalOpen = true;
  }


  closeClassesModal(): void {
    this.isClassesModalOpen = false;
  }


  openUnitsModal(): void {
    if (!this.selectedShortCourse) {
      return;
    }

    this.isClassesModalOpen = false;
    this.isUnitsModalOpen = true;
  }


  closeUnitsModal(): void {
    this.isUnitsModalOpen = false;
  }


  payNow(): void {
    if (!this.selectedShortCourse || !this.paymentCustomer.givenName || !this.paymentCustomer.email) {
      return;
    }

    const request: ShortCourseOrderModel = {
      id: 0,
      vetTrackId: Number(this.selectedShortCourse.id),
      shortCourseTitle: this.selectedShortCourse.courseName,
      studentGivenName: this.paymentCustomer.givenName,
      studentSingleName: this.paymentCustomer.familyName,
      studentEmail: this.paymentCustomer.email,
      totalAmount: Number(this.selectedShortCourse.amount || 0),
      currencyCode: 'AUD',
      stripeSessionId: null,
      stripePaymentIntentId: null,
      paymentStatus: 'Pending',
      createdDate: null,
      noOfSeatedLeft: this.selectedShortCourse.vacancies,
      type: "REGULAR",
      jobNo: null,
      startDate: this.selectedShortCourse.startDate,
      endDate: this.selectedShortCourse.endDate,
      duration: this.selectedCourseModalDetails.duration
    };

    this.orderService
      .createStripeShortCheckout(request)
      .subscribe({
        next: response => {

          if (response?.checkoutUrl) {
            sessionStorage.setItem('ecb_pending_booking',
              JSON.stringify(
                {
                  OrderId: response.orderId,
                  studentEmail: this.paymentCustomer.email,
                  totalAmount: Number(this.selectedShortCourse.amount || 0),
                  currencyCode: 'AUD',
                  courseName: this.selectedShortCourse.courseName,
                  courseCode: this.selectedShortCourse.courseCode,
                  startDate: this.selectedShortCourse.startDate,
                  startTime: this.selectedShortCourse.startTime,

                  duration:
                    this.selectedShortCourse.duration

                }
              ));

            window.location.href = response.checkoutUrl;
          } else {
            console.error('Stripe checkout URL was not returned.');
          }
        },
        error: error => {
          console.error('Stripe checkout failed:', error);
        }
      });
  }

  private updateSelectedCourseVacancies(
    vacancies: number
  ): void {
    if (!this.selectedShortCourse) {
      return;
    }

    this.selectedShortCourse = {
      ...this.selectedShortCourse,
      vacancies
    };
  }

  private loadAvailableSeats(
    vetTrackId: number,
    staticVacancies: number
  ): void {
    // Initially use the vacancies from the static/VETEnrol list.
    this.updateSelectedCourseVacancies(staticVacancies);

    this.orderService
      .GetAvailableSeatsByIdVetTrackId(vetTrackId)
      .subscribe({
        next: response => {
          /*
           * When an existing order record is found,
           * use the latest NoOfSeatedLeft value.
           */
          if (
            response &&
            response.noOfSeatedLeft !== null &&
            response.noOfSeatedLeft !== undefined
          ) {
            this.updateSelectedCourseVacancies(
              Math.max(0, Number(response.noOfSeatedLeft))
            );
          }
        },
        error: error => {
          /*
           * If there is no database record, the API may return 404.
           * Keep the static VETEnrol vacancies value.
           */
          if (error?.status === 404) {
            this.updateSelectedCourseVacancies(
              staticVacancies
            );

            return;
          }

          console.error(
            'Unable to retrieve available seats:',
            error
          );

          // Keep the fallback value for any API failure.
          this.updateSelectedCourseVacancies(
            staticVacancies
          );
        }
      });
  }

 isGroupBookingModalOpen = false;

openGroupBookingEnquiry(): void {
//  / this.isCourseModalOpen = false;

  setTimeout(() => {
    this.isGroupBookingModalOpen = true;
  }, 100);
}

closeGroupBookingEnquiry(): void {
  this.isGroupBookingModalOpen = false;
}
}
